window.onload = function () {
    let fiveMinutes = 60 * 15,
        display = document.querySelector('#count-down-timer');
    if (display) {
      startTimer(fiveMinutes, display);
    }
    
};

function startTimer(duration, display) {
    let timer = duration, minutes, seconds;
    setInterval(function () {
        minutes = parseInt(timer / 60, 10)
        seconds = parseInt(timer % 60, 10);

        minutes = minutes < 10 ? "0" + minutes : minutes;
        seconds = seconds < 10 ? "0" + seconds : seconds;

        display.textContent = minutes + ":" + seconds;

        
        if (--timer < 0) {
            timer = 0;
        }
    }, 1000);
}


